// extracted by mini-css-extract-plugin
export default {"text":"StudentMyProfile_text__g0tt4","subText":"StudentMyProfile_subText__HDlQe"};